import GlobalBatterySearch from "./GlobalBattery/GlobalBatterySearch";
import GlobalBatteryTypedValue from "./GlobalBattery/GlobalBatteryTypedValue";
import DeletedFromCart from "./DeletedFromCart";
import CustomOrder from "./CustomSortOrder/CustomOrder";

import { PassChangedSuccess } from "./Login";

import {
  StackTableOrder,
  StackTableSort,
  StackTableRowsPerPage,
} from "./BatteriesInStack";
import {
  AllBatteriesColumns,
  AllBatteriesHiddenColumns,
  AllBatteriesRowsPerPage,
  AllBatteriesState,
  AllBatteriesVolt,
  AllBatteriesSeverity,
  AllBatteriesCity,
  AllBatteriesZone,
  AllBatteriesStatus,
  AllBatteriesIOT,
  AllBatteriesPack,
  AllBatteriesBusiness,
  AllBatteriesMultiplePartners,
  AllBatteriesMultiplePartnersDropdown,
  AllBatteriesMultiplePartnersSelectAll,
  AllBatteriesUserInputBatteries,
  AllBatteriesFoundBatteries,
  AllBatteriesNotFoundBatteries,
  AllBatteriesBatteryPartnerSelect,
  AllBatteriesPageNumber,
  AllBatteriesStack,
  KPISort,
} from "./AllBatteries";

import {
  SessionExpired,
  TimeZoneChanged,
  RefreshAPICalled,
  DashboardType,
  DashboardColumns,
  DashboardHiddenColumns,
  IsBatteryIsPartnerIsNull,
  DashboardBatteryPartnerSelect,
  DashboardBatteryID,
  DashboardPartner,
  DashboardOrganization,
  DashboardCategory,
  DashboardLocation,
  DashboardStatus,
  DashboardSeverity,
  DashboardIOT,
  DashboardPack,
  DashboardTabValue,
  DashboardTabCounts,
  DashboardAlertTypeIndex,
  DashboardAlertTypeCode,
  DashboardTotal,
  DashboardStartDate,
  DashboardEndDate,
  DashboardAlertTypeList,
  DashboardListOfBatteries,
  DashboardStack,
  DashboardExistingBatteries,
  DashboardColumnSort,
  DashboardPageNumber,
  DashboardRowsPerPage,
  DashboardOpenAddSelectedBatteries,
  DashboardSelectedBatteriesAction,
  DashboardFilters,
} from "./Dashboard";

import {
  IsBatteryIsPartnerIsNullDiagnostics,
  DiagnosticsBatteryPartnerSelect,
  DiagnosticsColumns,
  DiagnosticsHiddenColumns,
  DiagnosticsBatteryID,
  DiagnosticsDeviceID,
  DiagnosticsPartner,
  DiagnosticsVolt,
  DiagnosticsCity,
  DiagnosticsZone,
  DiagnosticsPack,
  DiagnosticsIOT,
  DiagnosticsVersion,
  DiagnosticsBuildNo,
  DiagnosticsStatus,
  DiagnosticsTabValue,
  DiagnosticsErrorTypeIndex,
  DiagnosticsErrorTypeCode,
  DiagnosticsTotal,
  DiagnosticsStartDate,
  DiagnosticsEndDate,
  DiagnosticsErrorTypeList,
  DiagnosticsListOfBatteries,
  DiagnosticsStack,
  DiagnosticsSort,
  DiagnosticsPageNumber,
  DiagnosticsRowsPerPage,
  DiagnosticsOpenAddSelectedBatteries,
} from "./Diagnostics";

import {
  AnomalyColumns,
  AnomalyHiddenColumns,
  IsBatteryIsPartnerIsNullAnomaly,
  AnomalyBatteryID,
  AnomalyPartner,
  AnomalyVolt,
  AnomalyCell,
  AnomalyCity,
  AnomalyZone,
  AnomalyBuildNo,
  AnomalyVersion,
  AnomalyStatus,
  AnomalyTabValue,
  AnomalyIndex,
  AnomalyCode,
  AnomalyTotal,
  AnomalyStartDate,
  AnomalyEndDate,
  AnomalyList,
  AnomalyListOfBatteries,
  AnomalyStack,
  AnomalyColumnSort,
  AnomalyPageNumber,
  AnomalyRowsPerPage,
} from "./Anomaly";

import {
  IsBatteryIsPartnerIsNullWarranty,
  WarrantyColumns,
  WarrantyHiddenColumns,
  WarrantyBatteryID,
  WarrantyPartner,
  WarrantyVolt,
  WarrantyCity,
  WarrantyCell,
  WarrantyBusiness,
  WarrantyIOT,
  WarrantyAge,
  WarrantyCycle,
  WarrantyPack,
  WarrantySOH,
  WarrantyBuildNo,
  WarrantyVersion,
  WarrantyStatus,
  WarrantyTabValue,
  WarrantyIndex,
  WarrantyCode,
  WarrantyTotal,
  WarrantyStartDate,
  WarrantyEndDate,
  WarrantyList,
  WarrantyListOfBatteries,
  WarrantyStack,
  WarrantyColumnSort,
  WarrantyColumnSortOrder,
  WarrantyPageNumber,
  WarrantyRowsPerPage,
  WarrantyOpenAddSelectedBatteries,
} from "./Warranty";

import {
  AlertAnalyticsIOT,
  AlertAnalyticsPack,
  AlertAnalyticsGranularity,
  ReportAlertAnalyticsEndDate,
  ReportAlertAnalyticsStartDate,
} from "./Reports/AlertAnalytics";

import {
  ReportsDQIOT,
  ReportsDQPack,
  ReportsDQStartDate,
  ReportsDQEndDate,
  ReportsDQGranularity,
} from "./Reports/DataQuality";

import {
  BatteryHealthCycleAge,
  BatteryHealthToggleTable,
  BatteryHealthEqCycle,
  BatteryHealthSOH,
  BatteryHealthCell,
  BatteryHealthVolt,
  BatteryHealthBusiness,
  BatteryHealthIOT,
  BatteryHealthPack,
  BatteryHealthBatteryPartnerSelect,
  BatteryHealthBatteryID,
  BatteryHealthDeviceID,
  BatteryHealthPartner,
  BatteryHealthColumns,
  BatteryHealthSort,
  BatteryHealthSortOrder,
  BatteryHealthPageNumber,
  BatteryHealthRowsPerPage,
  BatteryLiveMetric,
} from "./BatteryHealth";

import {
  SpecificBatteryDateDisable,
  SpecificBatteryCarouselDate,
  SpecificBatteryDateInvalid,
} from "./SpecificBattery";

import {
  MapBatteryPartnerSelect,
  MapVolt,
  MapCity,
  MapStatus,
  MapSeverity,
  MapZone,
  MapAlertType,
  MapIotVendor,
  MapBatteryVendor,
  MapUserInputBatteries,
  MapFoundBatteries,
  MapNotFoundBatteries,
  MapMultiplePartners,
  MapFullScreen,
  MapSearch,
  MapSearchedBattery,
  MapClusterClick,
  OrgFilter,
} from "./Map";

import {
  DigitalTwinsColumns,
  DigitalTwinsHiddenColumns,
  DigitalTwinsBatteryID,
  DigitalTwinsIOT,
  DigitalTwinsApp,
  DigitalTwinsBMS,
  DigitalTwinsOrg,
  DigitalTwinsTabValue,
  DigitalTwinsTotal,
  DigitalTwinsStartDate,
  DigitalTwinsEndDate,
  DigitalTwinsListOfBatteries,
  DigitalTwinsPageNumber,
  DigitalTwinsRowsPerPage,
  DigitalTwinsColumnsSelect,
  DigitalTwinsConfigurationType,
  DigitalTwinsConfigFilters,
  DigitalTwinsColumnSort,
} from "./DigitalTwinsList";

import { 
  SelectedFilterValues,
  SelectedFilterDefaultValues,
  TableSortColumn,
  TableSortOrder,
  DialogTableSortColumn,
  DialogTableSortOrder,
  IsFiltersMounted
} from "./Filters"

import { 
  TableColumns,
  DialogBoxTableColumns,
  TablePageNumber,
  TableRowsPerPage,
  DialogTablePageNumber,
  DialogTableRowsPerPage
} from "./Table"
import { SelectedSearchType, SelectedSearchID, SelectedSearchConfig } from "./Search"

import { combineReducers } from "redux";
import {
  ChargingAnalyticsEndDate, ChargingAnalyticsStartDate
} from "./ChargingAnalytics";
import {
  AlertAnalyticsEndDate, AlertAnalyticsStartDate
} from "./AlertAnalytics";
import digitalTwinReducer from "./DigitalTwinReducer";
import UserPermissions from "./UserPermissions";

const rootReducer = combineReducers({
  SelectedFilterValues,
  SelectedFilterDefaultValues,
  SelectedSearchType,
  SelectedSearchID,
  SelectedSearchConfig,
  TableSortColumn,
  TableSortOrder,
  TableColumns,
  DialogBoxTableColumns,
  TablePageNumber,
  TableRowsPerPage,
  DialogTableSortColumn,
  DialogTablePageNumber,
  DialogTableRowsPerPage,
  DialogTableSortOrder,
  ChargingAnalyticsStartDate,
  ChargingAnalyticsEndDate,
  AlertAnalyticsStartDate,
  AlertAnalyticsEndDate,
  IsFiltersMounted,
  digitalTwin: digitalTwinReducer,

  PassChangedSuccess,

  GlobalBatterySearch,
  GlobalBatteryTypedValue,

  DeletedFromCart,
  DashboardStack,
  DashboardExistingBatteries,
  DiagnosticsStack,
  AllBatteriesStack,
  CustomOrder,
  DiagnosticsSort,
  DashboardColumnSort,
  KPISort,

  StackTableOrder,
  StackTableSort,
  StackTableRowsPerPage,

  AllBatteriesColumns,
  AllBatteriesHiddenColumns,
  AllBatteriesRowsPerPage,
  AllBatteriesState,
  AllBatteriesVolt,
  AllBatteriesCity,
  AllBatteriesSeverity,
  AllBatteriesZone,
  AllBatteriesStatus,
  AllBatteriesIOT,
  AllBatteriesPack,
  AllBatteriesMultiplePartners,
  AllBatteriesMultiplePartnersDropdown,
  AllBatteriesMultiplePartnersSelectAll,
  AllBatteriesUserInputBatteries,
  AllBatteriesFoundBatteries,
  AllBatteriesNotFoundBatteries,
  AllBatteriesBatteryPartnerSelect,
  AllBatteriesPageNumber,
  AllBatteriesBusiness,

  MapBatteryPartnerSelect,
  MapVolt,
  MapCity,
  MapStatus,
  MapSeverity,
  MapZone,
  MapAlertType,
  MapIotVendor,
  MapBatteryVendor,
  MapUserInputBatteries,
  MapFoundBatteries,
  MapNotFoundBatteries,
  MapMultiplePartners,
  MapFullScreen,
  MapSearch,
  MapSearchedBattery,
  MapClusterClick,
  OrgFilter,

  SessionExpired,
  TimeZoneChanged,
  RefreshAPICalled,
  DashboardType,
  DashboardColumns,
  DashboardHiddenColumns,
  IsBatteryIsPartnerIsNull,
  DashboardBatteryPartnerSelect,
  DashboardBatteryID,
  DashboardPartner,
  DashboardOrganization,
  DashboardCategory,
  DashboardLocation,
  DashboardSeverity,
  DashboardIOT,
  DashboardPack,
  DashboardStatus,
  DashboardTabValue,
  DashboardTabCounts,
  DashboardAlertTypeIndex,
  DashboardAlertTypeCode,
  DashboardTotal,
  DashboardStartDate,
  DashboardEndDate,
  DashboardAlertTypeList,
  DashboardListOfBatteries,
  DashboardPageNumber,
  DashboardRowsPerPage,
  DashboardOpenAddSelectedBatteries,
  DashboardSelectedBatteriesAction,
  DashboardFilters,

  IsBatteryIsPartnerIsNullDiagnostics,
  DiagnosticsBatteryPartnerSelect,
  DiagnosticsColumns,
  DiagnosticsHiddenColumns,
  DiagnosticsBatteryID,
  DiagnosticsPartner,
  DiagnosticsDeviceID,
  DiagnosticsVolt,
  DiagnosticsCity,
  DiagnosticsZone,
  DiagnosticsPack,
  DiagnosticsIOT,
  DiagnosticsVersion,
  DiagnosticsBuildNo,
  DiagnosticsStatus,
  DiagnosticsTabValue,
  DiagnosticsErrorTypeIndex,
  DiagnosticsErrorTypeCode,
  DiagnosticsTotal,
  DiagnosticsStartDate,
  DiagnosticsEndDate,
  DiagnosticsErrorTypeList,
  DiagnosticsListOfBatteries,
  DiagnosticsPageNumber,
  DiagnosticsRowsPerPage,
  DiagnosticsOpenAddSelectedBatteries,

  AnomalyColumns,
  AnomalyHiddenColumns,
  IsBatteryIsPartnerIsNullAnomaly,
  AnomalyBatteryID,
  AnomalyPartner,
  AnomalyVolt,
  AnomalyCell,
  AnomalyCity,
  AnomalyZone,
  AnomalyBuildNo,
  AnomalyVersion,
  AnomalyStatus,
  AnomalyTabValue,
  AnomalyIndex,
  AnomalyCode,
  AnomalyTotal,
  AnomalyStartDate,
  AnomalyEndDate,
  AnomalyList,
  AnomalyListOfBatteries,
  AnomalyStack,
  AnomalyColumnSort,
  AnomalyPageNumber,
  AnomalyRowsPerPage,

  WarrantyColumns,
  WarrantyHiddenColumns,
  IsBatteryIsPartnerIsNullWarranty,
  WarrantyBatteryID,
  WarrantyPartner,
  WarrantyVolt,
  WarrantyCity,
  WarrantyCell,

  WarrantyIOT,
  WarrantyAge,
  WarrantyCycle,
  WarrantyPack,
  WarrantySOH,

  WarrantyBusiness,
  WarrantyBuildNo,
  WarrantyVersion,
  WarrantyStatus,
  WarrantyTabValue,
  WarrantyIndex,
  WarrantyCode,
  WarrantyTotal,
  WarrantyStartDate,
  WarrantyEndDate,
  WarrantyList,
  WarrantyListOfBatteries,
  WarrantyStack,
  WarrantyColumnSort,
  WarrantyColumnSortOrder,
  WarrantyPageNumber,
  WarrantyRowsPerPage,
  WarrantyOpenAddSelectedBatteries,

  AlertAnalyticsIOT,
  AlertAnalyticsPack,
  AlertAnalyticsGranularity,
  ReportAlertAnalyticsEndDate,
  ReportAlertAnalyticsStartDate,

  ReportsDQIOT,
  ReportsDQPack,
  ReportsDQStartDate,
  ReportsDQEndDate,
  ReportsDQGranularity,

  BatteryHealthCycleAge,
  BatteryHealthToggleTable,
  BatteryHealthEqCycle,
  BatteryHealthSOH,
  BatteryHealthCell,
  BatteryHealthVolt,
  BatteryHealthBusiness,
  BatteryHealthIOT,
  BatteryHealthPack,
  BatteryHealthBatteryPartnerSelect,
  BatteryHealthBatteryID,
  BatteryHealthDeviceID,
  BatteryHealthPartner,
  BatteryHealthColumns,
  BatteryHealthPageNumber,
  BatteryHealthRowsPerPage,
  BatteryLiveMetric,

  SpecificBatteryDateDisable,
  SpecificBatteryCarouselDate,
  SpecificBatteryDateInvalid,
  BatteryHealthSort,
  BatteryHealthSortOrder,

  DigitalTwinsColumns,
  DigitalTwinsColumnsSelect,
  DigitalTwinsHiddenColumns,
  DigitalTwinsBatteryID,
  DigitalTwinsApp,
  DigitalTwinsIOT,
  DigitalTwinsBMS,
  DigitalTwinsOrg,
  DigitalTwinsTabValue,
  DigitalTwinsTotal,
  DigitalTwinsStartDate,
  DigitalTwinsEndDate,
  DigitalTwinsListOfBatteries,
  DigitalTwinsPageNumber,
  DigitalTwinsRowsPerPage,
  DigitalTwinsConfigurationType,
  DigitalTwinsConfigFilters,
  DigitalTwinsColumnSort,

  // RBAC Permissions
  UserPermissions,
});

export default rootReducer;
